export const formatChildrenAge = (age?: number | null) => {
  if (typeof age === 'number') {
    return age < 2 ? '&lt; 2' : String(age);
  }
  return '';
};

export const mapChildrenAgesToString = (childrenAges: Array<number>) => {
  return childrenAges.map((age) => formatChildrenAge(age));
};
